// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"80a2deaa","453":"aa5fd556"}[chunkId] + ".chunk.js";
};